module.exports = __webpack_public_path__ + "static/media/coverageThings1.8a4ae241.svg";